import {ResultatsMisesAJourComponent} from "./resultats/resultats-misesajour.component";
import {INotificationCatalogueExamenWebServiceClient, RechercheMiseAjourDto} from "./../../../../common/resources/resources";
import {ArianeElement, ArianeStore, FilterObject, WindowService} from "@digicerba/common";
import {Component, ViewChild} from "@angular/core";

@Component({
  selector: 'historique-modifications',
  templateUrl: './historique-modifications.component.html',
  host: { 'class': 'page' }
})
export class HistoriqueModificationsComponent {

  filtreObjet: RechercheMiseAjourDto;

  results: number = 0;
  @ViewChild(ResultatsMisesAJourComponent) resultatsComponent: ResultatsMisesAJourComponent;

  constructor(arianeStore: ArianeStore, notificationCatalogueExamenService: INotificationCatalogueExamenWebServiceClient, private windowService: WindowService) {
    notificationCatalogueExamenService.markAsReadMisesAJour();

    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.HOME",
        route: "/accueil"
      },
      {
        libelle: "ARIANE.MODIFICATIONS",
        route: "/"
      }
    ]
    arianeStore.updateElements(arianeElements);
  }

  onFiltering(filters: RechercheMiseAjourDto) {
    this.filtreObjet = filters;
  }

  onResults(nb: number) {
    this.results = nb;
  }

  print() {
    this.windowService.openPrint();
  }

  export() {
    this.resultatsComponent.export();
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/historique-modifications/historique-modifications.component.ts